export default __webpack_public_path__ + "static/media/6.d815547f.jpg";